import React, { useEffect } from 'react';
import { toast } from 'sonner';
import { RewardClaimToast } from './RewardClaimToast';
import { TIP_TOAST_OPTIONS } from './TipToastFrame';

export const useRewardClaimNotifications = (userId, mounted, toastIds, playSound) => {
  useEffect(() => {
    const key = `gv_reward_alerts_seen_${userId}`;
    let shown = new Set();
    try { shown = new Set(JSON.parse(sessionStorage.getItem(key)) || []); } catch { /* In-memory dedup remains. */ }
    const claimed = (event) => {
      const receipt = event.detail;
      if (!mounted.current || receipt?.user_id !== userId || !['rakeback', 'daily'].includes(receipt.kind) || !receipt.request_id || !(receipt.amount_minor > 0)) return;
      const unique = `${receipt.kind}:${receipt.request_id}`;
      if (shown.has(unique)) return;
      shown.add(unique);
      try { sessionStorage.setItem(key, JSON.stringify([...shown].slice(-500))); } catch { /* In-memory dedup remains. */ }
      const id = `reward-${userId}-${unique}`;
      toast.custom(() => <RewardClaimToast receipt={receipt} dismiss={() => toast.dismiss(id)} />, { ...TIP_TOAST_OPTIONS, id });
      toastIds.current.push(id); playSound(id);
    };
    window.addEventListener('gv-reward-claimed', claimed);
    return () => window.removeEventListener('gv-reward-claimed', claimed);
  }, [userId, mounted, toastIds, playSound]);
};